export default __webpack_public_path__ + "static/media/logo.02e5513c.svg";